 import React, { Component } from "react";
import { withLocalize } from "react-localize-redux";
import "./style.scss";

class TopicData extends Component {

    onChangeInput = () => {
        return 0;
    }

    showItemDetail = () => {
        var element = document.getElementById("back");
        element.classList.add("show");
    }

    hideItemDetail = () => {
        var element = document.getElementById("back");
        element.classList.remove("show");
    }

    showItemDetail2 = () => {
        var element = document.getElementById("back2");
        element.classList.add("show");
    }

    hideItemDetail2 = () => {
        var element = document.getElementById("back2");
        element.classList.remove("show");
    }

    drag = (e) => {
        e.dataTransfer.setData("text", e.target.id);
    }

    drag2 = (i) => {
        this.props.tranferIndex(i);
    }

    render(){
        return(
            <div className="topic-data">
                <div className="front">
                    <h4 className="title">打撃</h4>
                    <ul className="dropdown-menu">
                        <li className="item" onClick={this.showItemDetail} >打撃成績</li>
                        <li className="item" onClick={this.showItemDetail} >打球割合</li>
                        <li className="item" onClick={this.showItemDetail} >スイング系</li>
                        <li className="item" onClick={this.showItemDetail} >その他</li>
                        <li className="item" onClick={this.showItemDetail2} >ビジュアル</li>
                        <li className="item" onClick={this.showItemDetail} >カスタムレポート</li>
                    </ul>
                    <h4 className="title mt-24">投球</h4>
                    <ul className="dropdown-menu">
                        <li className="item" onClick={this.showItemDetail} >打撃成績</li>
                        <li className="item" onClick={this.showItemDetail} >打球割合</li>
                        <li className="item" onClick={this.showItemDetail} >スイング系</li>
                        <li className="item" onClick={this.showItemDetail} >その他</li>
                        <li className="item" onClick={this.showItemDetail2} >ビジュアル</li>
                        <li className="item" onClick={this.showItemDetail} >カスタムレポート</li>
                    </ul>
                </div>

                <div className="back" id="back">
                    <h4 className="title"><span onClick={this.hideItemDetail} ></span>打撃成績</h4>
                    <span className="sub-title">ドラッグ&ドロップで左の枠に追加します</span>
                    <div className="block-form" id="drag" onDrop={this.drop} onDragOver={this.allowDrop} >
                        <li className="form-input" draggable={true} onDragStart={this.drag} id="drag1" >内角</li>
                        <li className="form-input" draggable={true} onDragStart={this.drag} id="drag2" >外角</li>
                        <li className="form-input" draggable={true} onDragStart={this.drag} id="drag3" >高め</li>
                        <li className="form-input" draggable={true} onDragStart={this.drag} id="drag4" >低め</li>
                        <li className="form-input" draggable={true} onDragStart={this.drag} id="drag5" >ストライクゾーン</li>
                        <li className="form-input" draggable={true} onDragStart={this.drag} id="drag6" >ボールゾーン</li>
                        <li className="form-input" draggable={true} onDragStart={this.drag} id="drag7" >ファーストストライク</li>
                        <li className="form-input" draggable={true} onDragStart={this.drag} id="drag8" >対左投手</li>
                        <li className="form-input" draggable={true} onDragStart={this.drag} id="drag9" >対右投手</li>
                        <li className="form-input" draggable={true} onDragStart={this.drag} id="drag10" >ストレート</li>
                        <li className="form-input" draggable={true} onDragStart={this.drag} id="drag11" >変化球</li>
                        <li className="form-input" draggable={true} onDragStart={this.drag} id="drag12" >140km/h以上</li>
                        <li className="form-input" draggable={true} onDragStart={this.drag} id="drag13" >150km/h以上</li>
                        <li className="form-input" draggable={true} onDragStart={this.drag} id="drag14" >0,1ストライク</li>
                        <li className="form-input" draggable={true} onDragStart={this.drag} id="drag15" >2ストライク</li>
                        <li className="form-input" draggable={true} onDragStart={this.drag} id="drag16" >得点圏</li>
                        <li className="form-input" draggable={true} onDragStart={this.drag} id="drag17" >走者あり</li>
                        <li className="form-input" draggable={true} onDragStart={this.drag} id="drag18" >ビハインド</li>
                        <li className="form-input" draggable={true} onDragStart={this.drag} id="drag19" >代打</li>
                    </div>
                </div>


                <div className="back" id="back2">
                    <h4 className="title"><span onClick={this.hideItemDetail2} ></span>ビジュアル</h4>
                    <span className="sub-title">ドラッグ&ドロップで左の枠に追加します</span>
                    <div className="block-form" id="drag" onDrop={this.drop} onDragOver={this.allowDrop} >
                        <li className="form-input" draggable={true} onDragStart={ this.drag} id="drag20" >棒グラフ</li>
                        <li className="form-input" draggable={true} onDragStart={ this.drag} id="drag21" >折れ線グラフ</li>
                        <li className="form-input" draggable={true} onDragStart={ this.drag} id="drag22" >ホットゾーン</li>
                        <li className="form-input" draggable={true} onDragStart={ this.drag} id="drag23" >打球方向</li>

                    </div>
                </div>
            </div>
        )
    }
}

export default withLocalize(TopicData);
